import React from 'react';

export interface TimerStyle02Props {
  value?: string;
  options: string[];
  disabled?: boolean;
  loading?: boolean;
  onChange: (value: string) => void;
  label?: string;
  labels?: Record<string, string>;
  columns?: number;
}

/**
 * Timer Style 02 - Grid
 * Grid layout with multiple timer options
 */
export const Style02_Grid: React.FC<TimerStyle02Props> = ({
  value,
  options,
  disabled = false,
  loading = false,
  onChange,
  label = '定時器',
  labels = {
    '0': '關閉', '1': '1 小時', '2': '2 小時', '3': '3 小時',
    '4': '4 小時', '5': '5 小時', '6': '6 小時', '7': '7 小時',
    '8': '8 小時', '9': '9 小時', '10': '10 小時', '11': '11 小時', '12': '12 小時'
  },
  columns = 3
}) => {
  return (
    <div className="space-y-3">
      <span className="text-sm text-slate-300">{label}</span>
      <div className={`grid gap-2`} style={{ gridTemplateColumns: `repeat(${columns}, 1fr)` }}>
        {options.map((option) => {
          const isSelected = value === option;
          return (
            <button
              key={option}
              onClick={() => onChange(option)}
              disabled={disabled || loading}
              className={`py-2 px-2 rounded-lg text-sm font-medium transition-all ${
                isSelected
                  ? 'bg-blue-500 text-white'
                  : 'bg-slate-700/50 text-slate-400 hover:bg-slate-600/50'
              } ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
            >
              {loading && isSelected ? '...' : labels[option] || `${option} 小時`}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default Style02_Grid;
